import React from 'react'
import { Typography } from '@mui/material'
import {
  DatePickerV2,
  labraUIDateFormat,
  TextInputV4,
} from '@labrav/react-components'
import { get, isEmpty } from 'lodash'
import { useStyles } from './TotalContractValueSection.styles'
import { DateTime } from 'luxon'
import { FormikProps } from 'formik'

export interface TotalContractValueSectionProps {
  tcvValue: number | undefined
  firstInstallmentDateValue: string | undefined
  touched: {
    tcv?: boolean
    firstInstallmentDate?: boolean
  }
  errors: {
    tcv?: string
    firstInstallmentDate?: string
  }
  onTcvChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onFirstInstallmentDateChange: (date: string | null) => void
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void
  minDate?: string
  maxDate?: string
  formik?: FormikProps<Record<string, unknown>>
  validate?: boolean
}

export const TotalContractValueSection = ({
  tcvValue,
  touched,
  errors,
  onTcvChange,
  onFirstInstallmentDateChange,
  onBlur,
  minDate,
  maxDate,
  formik,
  validate = false,
}: TotalContractValueSectionProps) => {
  const { classes } = useStyles()

  return (
    <>
      <Typography className={classes.sectionHeading}>
        Total contract value
      </Typography>
      <div className={classes.fieldRow}>
        <div className={classes.inputWidth}>
          <TextInputV4
            keyName="tcv"
            title="Enter total contract value"
            type="number"
            placeHolder=""
            value={tcvValue as number | ''}
            updatedValue={tcvValue as number | ''}
            maxNumber={72}
            isError={
              !!(get(touched, 'tcv', false) && get(errors, 'tcv', false))
            }
            errorText={
              (!!get(touched, 'tcv', false) && get(errors, 'tcv', '')) || ''
            }
            onChange={onTcvChange}
            isReadOnly={false}
            isRequired={false}
            showSpinner={false}
            onBlur={onBlur}
            keyToPrevent={['+', '-', 'e']}
            alignRight
          />
        </div>
        <div className={classes.inputWidth}>
          <DatePickerV2
            format={labraUIDateFormat}
            field={{
              title: 'First installment date',
              humanReadableKey: 'firstInstallmentDate',
              id: 'firstInstallmentDate',
              isRequired: false,
              isReadOnly: false,
              dataType: 'date',
              minDate: minDate
                ? minDate
                : DateTime.now().plus({ days: 1 }).toISODate(),
              maxDate: maxDate ? maxDate : '',
            }}
            {...(formik && {
              formik: formik as FormikProps<Record<string, unknown>>,
            })}
            views={['year', 'month', 'day']}
            key={'firstInstallmentDate'}
            showErrorHelper={
              !!touched.firstInstallmentDate &&
              !isEmpty(errors?.firstInstallmentDate)
            }
            fieldId={'firstInstallmentDate'}
            handleDateChange={onFirstInstallmentDateChange}
            errorHelperText={
              (!!touched?.firstInstallmentDate &&
                errors?.firstInstallmentDate) ||
              ''
            }
            size="small"
            validate={validate}
          />
        </div>
      </div>
    </>
  )
}
